<template>
  <div class="sc-support-wrapper" v-show="!widgetExists || !zohoSalesIQChatEnabled">
    <div class="sc-float" title="Support" @click="showSupportModal = !showSupportModal">
      <font-awesome-icon
        :icon="showSupportModal ? 'fa-solid fa-x' : 'fa-solid fa-headset'"
        class="icon"
        :class="[showSupportModal ? 'sc-close-icon' : '']"
        :style="{ color: 'white' }"
      />
    </div>
  </div>
  <SupportModal id="supportModal" @close="showSupportModal = false" v-if="showSupportModal" />
</template>

<script setup lang="ts">
import { LenderBranding } from "@/store/applicationsModule";
import { onMounted, ref, watch, onUnmounted, computed } from "vue";
import SupportModal from "@/components/modals/SupportModal.vue";

const props = defineProps<{
  zohoSalesIQChatEnabled: boolean;
  branding?: LenderBranding;
}>();

const zohoReady = ref<boolean>(false);
const zohoSalesIqError = ref<boolean>(false);
const showSupportModal = ref<boolean>(false);
const retries = ref<number>(0);
const MAX_RETRIES = 100; //10 seconds
const widgetExists = computed<boolean>(() => {
  return (
    document.querySelector("#zsiq_float") !== null &&
    document.querySelector("#zsiq_float") !== undefined
  );
});

function initializeZohoSalesIQ() {
  //1. Initialize Zoho SalesIQ global object
  (window as any).$zoho = (window as any).$zoho || {};

  // 2. Define the SalesIQ-specific object
  (window as any).$zoho.salesiq = (window as any).$zoho.salesiq || {};

  // 3. Test Zoho Sales IQ functionality
  (window as any).$zoho.salesiq.ready = function () {
    if ((window as any).$zoho?.salesiq?.floatbutton) {
      zohoReady.value = true;

      console.log(
        "initializeZohoSalesIQ ready function",
        props.zohoSalesIQChatEnabled ? "show" : "hide",
      );

      (window as any).$zoho.salesiq.floatbutton.visible(
        props.zohoSalesIQChatEnabled ? "show" : "hide",
      );
    }
  };

  // if script already exists
  if (document.getElementById("zsiqscript")) {
    console.log("Script already exists");
    onDOMContentLoaded();
    zohoReady.value = true;

    return;
  }

  // Prevent duplicate script injection
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.id = "zsiqscript";
  script.src =
    "https://salesiq.zohopublic.com/widget?wc=siq28d5720ca34fbb7cc9a1ea506a9c718a8ebfebe1d6d6bb96cc0098784800784b7315b7f95ef32f45e64325dfd21bc1ac";
  script.defer = true;

  script.onerror = event => {
    if (script.src.includes("salesiq.zohopublic.com")) {
      console.error("Failed to load Zoho SalesIQ script.", event); // Check if the failed script's src is the expected Zoho URL
      zohoSalesIqError.value = true;
    }
  };

  document.body.appendChild(script);
}

function onDOMContentLoaded() {
  // Check if the Zoho object has initialized
  function checkSalesIQ() {
    console.log("checkSalesIQ");

    if (!props.zohoSalesIQChatEnabled) {
			console.log('zohoSalesIQ is not enabled');
      return;
    }

    if (
      typeof (window as any).$zoho !== "undefined" &&
      typeof (window as any).$zoho?.salesiq !== "undefined" &&
      (window as any).$zoho?.salesiq?.floatbutton
    ) {
      zohoSalesIqError.value = props.zohoSalesIQChatEnabled ? false : true;

      // Your custom logic or JS API execution here
      console.log("SalesIQ is available!", {
        siq: (window as any).$zoho?.salesiq,
        floatbutton: (window as any).$zoho?.salesiq?.floatbutton,
      });

      console.log(
        `called $zoho.salesiq.floatbutton?.visible("${props.zohoSalesIQChatEnabled ? "show" : "hide"}")`,
      );

      (window as any).$zoho?.salesiq?.floatbutton?.visible(
        props.zohoSalesIQChatEnabled ? "show" : "hide",
      );
    }

    if (retries.value >= MAX_RETRIES) {
      zohoSalesIqError.value = true;
      console.log("ZohoSalesIQ failed to load.");
      return;
    }

    zohoSalesIqError.value = true;
		retries.value++;
    // Poll every 100ms until the script loads
    setTimeout(checkSalesIQ, 100);
  }

  checkSalesIQ();
}

onMounted(() => {
  initializeZohoSalesIQ();

  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
});

onUnmounted(() => {
  document.removeEventListener("DOMContentLoaded", onDOMContentLoaded);
});
/////////////////////////////////////////////////////////////////////////
//#TODO more investigation also watch the lender's primary color, if any
/////////////////////////////////////////////////////////////////////////
// const defaultThemeColor = ref<string | null>(null);

// const color = computed<string>(() => {
//   if (props.branding?.primaryColor) {
//     return `${props.branding.primaryColor} !important`;
//   }
//   return defaultThemeColor.value || "#f7941e";
// });

// function applyTheme() {
//   if (!zohoReady.value) return;

//   const floatElement = document.body.querySelector(".zsiq_float") as HTMLElement | null;

//   if (!floatElement) {
//     zohoSalesIqError.value = true;
//     return;
//   }

//   zohoSalesIqError.value = false;

//   try {
//     // Set the theme color for the floating chat button and chat window
//     (window as any).$zoho.salesiq.chat.theme({
//       color: color.value, // Replace with your desired HEX color
//     });
//   } catch (e) {
//     console.error("Error setting Zoho SalesIQ theme color:", e);
//   }

//   // Apply lender branding
//   document.documentElement.style.setProperty("--theme-color", `${color.value} !important`);
//   document.documentElement.style.setProperty(
//     "--siqcw-custom-text-color",
//     `${color.value} !important`,
//   );
//   document.documentElement.style.setProperty(
//     "--siqcw-custom-icon-color",
//     `${color.value} !important`,
//   );
//   document.documentElement.style.setProperty(
//     "--zsiqf-custom-bg-color",
//     `${color.value} !important`,
//   );
//   document.documentElement.style.setProperty(
//     "--siqcw-custom-border-color",
//     `${color.value} !important`,
//   );
//   document.documentElement.style.setProperty("--zsiqf-custom-bg", `${color.value} !important`);
//   document.documentElement.style.setProperty("--zsiqf-cw-bg-color", `${color.value} !important`);
//   document.documentElement.style.setProperty(
//     "--siqcw-header-bg-color",
//     `${color.value} !important`,
//   );
//   document.documentElement.style.setProperty(
//     "--siqcw-custom-dark-icon-color",
//     `${color.value} !important`,
//   );
// }

// watch(
//   () => props.branding?.primaryColor,
//   () => {
//     applyTheme();
//   },
//   {
//     immediate: true,
//   },
// );
/////////////////////////////////////////////////////////////////////////
watch(
  () => widgetExists.value,
  () => {
    console.log("widgetExists", widgetExists.value);
    if (widgetExists.value) {
      zohoSalesIqError.value = props.zohoSalesIQChatEnabled ? false : true;
      console.log("widgetExists toggle visibility", props.zohoSalesIQChatEnabled ? "show" : "hide");

      (window as any).$zoho?.salesiq?.floatbutton?.visible(
        props.zohoSalesIQChatEnabled ? "show" : "hide",
      );
    } else {
      zohoSalesIqError.value = true;
    }
  },
);

watch(
  () => [zohoReady, props.zohoSalesIQChatEnabled],
  ([ready, enabled]) => {
    // do not validate before initialized
    if (!ready) {
      console.log("Zoho Sales IQ not ready yet");
      return;
    }
    console.log("Zoho Sales IQ ready", {
      siq: (window as any).$zoho?.salesiq,
      floatbutton: (window as any).$zoho?.salesiq?.floatbutton,
      enabled,
    });

    if (props.zohoSalesIQChatEnabled) {
      console.log('called $zoho.salesiq.floatbutton?.visible("show")');
      (window as any).$zoho?.salesiq?.floatbutton?.visible("show");
      zohoSalesIqError.value = false;
    } else {
      console.log('called $zoho.salesiq.floatbutton?.visible("hide")');
      zohoSalesIqError.value = true;
      (window as any).$zoho?.salesiq?.floatbutton?.visible("hide");
    }
  },
  {
    immediate: true,
  },
);

defineExpose({
  zohoSalesIqError,
  widgetExists,
});
</script>
<style>
:root {
  --siqcw-header-bg-color: var(--theme-color, #f7941e);
  --siqcw-custom-text-color: var(--theme-color, #f7941e);
  --siqcw-custom-icon-color: var(--theme-color, #f7941e);
  --siqcw-custom-bg-color: var(--theme-color, #f7941e);
  --siqcw-custom-border-color: var(--theme-color, #f7941e);
  --zsiqf-cw-bg-color: var(--theme-color, #f7941e);

  --sc-float-close-height: 55px;
  --sc-bg-color: var(--theme-color, #f7941e);
  --sc-float-close-height: 55px;
  --sc-float-image-position: 0px;
  --sc-icon-color: white;
}

.sc-support-wrapper {
  box-sizing: border-box;
  position: relative;
  z-index: 2247483647 !important;
}

.sc-float {
  justify-content: center;
  align-items: center;
  display: flex;
}

.sc-float {
  background: var(--sc-bg-color);
  background-color: var(--theme-color);
  color: var(--theme-color);
  border-radius: 100%;
  bottom: 10px;
  cursor: pointer;
  font-size: 15px;
  height: var(--sc-float-close-height);
  padding: 3px;
  position: fixed;
  right: calc(10px + var(--sc-float-image-position));
  width: var(--sc-float-close-height);
}

.sc-support-wrapper .icon {
  line-height: 1;
  font-size: 25px;
  transform: scale(1);
  color: var(--sc-icon-color);
}

.sc-close-icon {
  animation: rotate-anim 0.4s linear forwards;
  height: 25px;
}

@media (max-width: 554px) {
  .sc-float {
    transform: scale(0.8) !important;
  }
}

@keyframes rotate-anim {
  0% {
    opacity: 0;
    transform: rotate(-25deg);
  }
  100% {
    opacity: 1;
    transform: rotate(0);
  }
}
</style>
